"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionParentType = exports.CodingQuestion = void 0;
var typeorm_1 = require("typeorm");
var Company_1 = require("./Company");
var Tag_1 = require("./Tag");
var DifficultyType;
(function (DifficultyType) {
  DifficultyType["EASY"] = "EASY";
  DifficultyType["MEDIUM"] = "MEDIUM";
  DifficultyType["HARD"] = "HARD";
})(DifficultyType || (DifficultyType = {}));
var QuestionType;
(function (QuestionType) {
  QuestionType["DSA"] = "DSA";
  QuestionType["ALGO"] = "ALGO";
  QuestionType["DP"] = "Dynamic Programming";
})(QuestionType || (QuestionType = {}));
var QuestionParentType;
(function (QuestionParentType) {
  QuestionParentType["PRECOURSE"] = "PRECOURSE";
  QuestionParentType["MODULE"] = "MODULE";
  QuestionParentType["CONTEST"] = "CONTEST";
  QuestionParentType["OTHER"] = "OTHER";
})(QuestionParentType || (QuestionParentType = {}));
exports.QuestionParentType = QuestionParentType;
var CodingQuestion = /** @class */function () {
  function CodingQuestion() {}
  __decorate([(0, typeorm_1.PrimaryGeneratedColumn)("uuid"), __metadata("design:type", String)], CodingQuestion.prototype, "id", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], CodingQuestion.prototype, "statement", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null,
    length: 511
  }), __metadata("design:type", String)], CodingQuestion.prototype, "title", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: DifficultyType.EASY,
    type: "enum",
    enum: DifficultyType
  }), __metadata("design:type", String)], CodingQuestion.prototype, "difficulty", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: 0
  }), __metadata("design:type", Number)], CodingQuestion.prototype, "score", void 0);
  __decorate([(0, typeorm_1.ManyToMany)(function () {
    return Tag_1.Tag;
  }, {
    eager: true
  }), (0, typeorm_1.JoinTable)({
    name: "coding_question_tag_m2m"
  }), __metadata("design:type", Array)], CodingQuestion.prototype, "tags", void 0);
  __decorate([(0, typeorm_1.ManyToMany)(function () {
    return Company_1.Company;
  }, {
    eager: true
  }), (0, typeorm_1.JoinTable)({
    name: "cq_company_m2m"
  }), __metadata("design:type", Array)], CodingQuestion.prototype, "companies", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: "DSA",
    type: "enum",
    enum: QuestionType
  }), __metadata("design:type", String)], CodingQuestion.prototype, "question_type", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], CodingQuestion.prototype, "solution", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], CodingQuestion.prototype, "editorial", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: ""
  }), __metadata("design:type", String)], CodingQuestion.prototype, "javaPreDriverCode", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: ""
  }), __metadata("design:type", String)], CodingQuestion.prototype, "cPreDriverCode", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: ""
  }), __metadata("design:type", String)], CodingQuestion.prototype, "cppPreDriverCode", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: ""
  }), __metadata("design:type", String)], CodingQuestion.prototype, "pythonPreDriverCode", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: ""
  }), __metadata("design:type", String)], CodingQuestion.prototype, "jsPreDriverCode", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: ""
  }), __metadata("design:type", String)], CodingQuestion.prototype, "defaultInput", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: ""
  }), __metadata("design:type", String)], CodingQuestion.prototype, "expectedDefaultOutput", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: false
  }), __metadata("design:type", Boolean)], CodingQuestion.prototype, "isInputRequired", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: [],
    type: "jsonb"
  }), __metadata("design:type", Array)], CodingQuestion.prototype, "hints", void 0);
  __decorate([(0, typeorm_1.Column)({
    type: "jsonb",
    nullable: true,
    default: []
  }), __metadata("design:type", Array)], CodingQuestion.prototype, "testCase", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: QuestionParentType.PRECOURSE,
    type: "enum",
    enum: QuestionParentType
  }), __metadata("design:type", String)], CodingQuestion.prototype, "parentType", void 0);
  __decorate([(0, typeorm_1.CreateDateColumn)(), __metadata("design:type", Date)], CodingQuestion.prototype, "createdAt", void 0);
  __decorate([(0, typeorm_1.UpdateDateColumn)(), __metadata("design:type", Date)], CodingQuestion.prototype, "updatedAt", void 0);
  CodingQuestion = __decorate([(0, typeorm_1.Entity)()], CodingQuestion);
  return CodingQuestion;
}();
exports.CodingQuestion = CodingQuestion;